module.exports = __webpack_public_path__ + "static/income_0.8f24ec4a.jpg";